// src/components/main/MainLoader.js
import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';

/**
 * MainLoader (v4)
 * • Static tree crest.
 * • Curved white text ring spins counter-clockwise.
 * • Even spacing ensured via SVG textLength + lengthAdjust.
 */
const MainLoader = () => {
  const theme = useTheme();

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.8 } }}
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        bgcolor: 'common.black',          // ← changed to black background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box sx={{ position: 'relative', width: 200, height: 200 }}>
        {/* Counter-clockwise curved text (two instances 180° apart) */}
        <motion.svg
          viewBox="0 0 100 100"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
          animate={{ rotate: [360, 0] }}
          transition={{ duration: 28, ease: 'linear', repeat: Infinity }}
        >
          <defs>
            <path id="circlePath" d="M50 50 m -42 0 a 42 42 0 1 1 84 0 a 42 42 0 1 1 -84 0" />
          </defs>
          <text
            fill={theme.palette.common.white}
            fontSize="7"
            fontFamily="'Playfair Display', serif"
            letterSpacing="2"
            textAnchor="middle"
          >
            <textPath href="#circlePath" startOffset="0%">•</textPath>
            <textPath href="#circlePath" startOffset="25%">MARRAKECH&nbsp;RESERVE</textPath>
            <textPath href="#circlePath" startOffset="50%">•</textPath>
            <textPath href="#circlePath" startOffset="75%">MARRAKECH&nbsp;RESERVE</textPath>
          </text>
        </motion.svg>

        {/* Static tree crest */}
        <img
          src="https://brokepiggytoken.xyz/wp-content/uploads/2025/07/tree_logo_loader.png"
          alt="Marrakech Reserve logo"
          style={{
            width: '70%',
            height: '70%',
            objectFit: 'contain',
            position: 'absolute',
            top: '15%',
            left: '15%',
          }}
        />
      </Box>
    </Box>
  );
};

export default MainLoader;
